import React from 'react';
import PropTypes from 'prop-types';

import {
	Typography
} from '@material-ui/core';

import Constants from "../utils/Constants";
import HTMLEntities from "../utils/HTMLEntities";
import GSuiteContent from "./GSuiteContent";
import TwitterRedaction from "./TwitterRedaction";

function ActivityListItemContent(props) {
	let { content, sourceId, subSourceId, patch, category, twitterRedacted, history, searchTerm } = props,
		isGDoc = sourceId === Constants.SOURCES.IDS.GOOGLE_DOCS,
		isGSuiteComment = subSourceId === Constants.SOURCES.IDS.GSUIT_COMMENT;
	/*{priorComments} = props,*/

	const highlightText = (text) => {
		if (!searchTerm || searchTerm.length <= 2) return text;

		const regex = new RegExp(`(${searchTerm})`, 'gi');
		const highlightedText = text ? HTMLEntities.decode(text).replace(
			regex,
			(match) => `<span style="background-color: #f9894b;">${match}</span>`
		) : ''	;
		return highlightedText;
	};

	return (
		<React.Fragment>
			{isGDoc && !isGSuiteComment ?
				<GSuiteContent
					patch={patch} />
				:
				twitterRedacted && twitterRedacted !== Constants.ACTIVITY.TWITTER_REDACTION.SCRUB_GEO ? (
					<TwitterRedaction
						shortMessage
						history={history}
						twitterRedacted={twitterRedacted}
						isAlert={category === Constants.ACTIVITY.CATEGORIES.ALERTS.ID} />
				) : <Typography
					component="div"
					dangerouslySetInnerHTML={{ __html: highlightText(content) }}
				/>
			}

			{/*{isGSuiteComment ?
				<Typography variant="caption">{priorComments.length} more comments</Typography> : null
			}*/}
		</React.Fragment>
	);
}

ActivityListItemContent.propTypes = {
	content: PropTypes.string,
	patch: PropTypes.string,
	sourceId: PropTypes.number,
	subSourceId: PropTypes.string,
	priorComments: PropTypes.array,
	category: PropTypes.number,
	twitterRedacted: PropTypes.string,
	history: PropTypes.object
};

export default ActivityListItemContent;